import React from 'react';
import { Link } from 'react-router-dom';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-background text-foreground py-16 px-6">
      <div className="max-w-2xl mx-auto">
        {/* Logo / Back link */}
        <Link to="/" className="inline-flex items-center space-x-3 mb-12 hover:opacity-80 transition-opacity">
          <img
            src="/brand/depthme-icon-192.png"
            alt="DepthMe Logo"
            className="w-10 h-10 object-contain"
          />
          <span className="text-lg font-semibold text-foreground">DepthMe</span>
        </Link>

        <h1 className="text-4xl font-bold text-foreground mb-2">Contact Us</h1>
        <p className="text-muted-foreground mb-10 leading-relaxed">
          We're here to help. Reach out and we'll get back to you within 48 hours.
        </p>

        <div className="glassmorphism rounded-2xl p-8 space-y-6">

          <div>
            <h2 className="text-base font-semibold text-accent mb-3">Get in touch</h2>
            <p className="text-muted-foreground leading-relaxed mb-3">
              Whether it's a question, feedback, a privacy request, or a billing query — send us a note and we'll get back to you.
            </p>
            <a
              href="mailto:hello@depthme.app"
              className="text-primary text-lg font-medium hover:underline"
            >
              hello@depthme.app
            </a>
          </div>

          <div className="pt-4 border-t border-border/30">
            <p className="text-sm text-muted-foreground/60">
              You can also open the app directly:{' '}
              <a
                href="https://depthme.app"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary hover:underline"
              >
                depthme.app
              </a>
            </p>
          </div>

        </div>

        <Link to="/" className="inline-flex items-center space-x-2 mt-10 text-sm text-primary hover:underline">
          <span>←</span>
          <span>Back to DepthMe</span>
        </Link>
      </div>
    </div>
  );
};

export default ContactPage;
